import CheckoutBasketItem from "./CheckoutBasketItem.js";

/**
 * Checkout basket service
 *
 * Utility methods for interacting with checkout basket instances.
 *
 * @package HOPS
 * @subpackage Checkout
 * @author Heron Web Ltd
 * @copyright Heritage Operations Processing Limited
 */
class CheckoutBasketService {

	/**
	 * Get the total value of a basket, while considering applied discounts.
	 *
	 * @param {Array<Object>} items CheckoutBasketItem-like objects
	 * @param {Array<Object>} discounts API basket discount claim objects
	 * @return {Integer} Pence, inc. VAT
	 */
	static getBasketTotal(items, discounts) {
		return (items || []).reduce((v, i) => {

			/**
			 * Get the discounts for this item claim
			 */
			const itemDiscounts = (discounts || []).filter(discount => (discount.ItemClaim === i.Uuid));

			/**
			 * Get the total amount of discount for this item
			 */
			const itemDiscountsTotal = itemDiscounts.reduce((v, discount) => {
				return (v + (discount.Discount.Amount * Math.min(discount.DiscountQty, i.Quantity)));
			}, 0);

			if (i.Quantity > 0) {
				// Positive item quantity bound
				return (v + Math.max((CheckoutBasketItem.getTotalPrice(i) - itemDiscountsTotal), 0));
			}
			else {
				return (v + CheckoutBasketItem.getTotalPrice(i));
			}

		}, 0);
	}

}

export default CheckoutBasketService;
